interface EventBusListener {
  [key: string]: Function[];
}

class EventBus {
  /**
   * 存放所有事件的回调列表
   */
  listeners: EventBusListener = {};

  /**
   * 监听事件
   * @param type 事件类型
   * @param callback 回调函数
   */
  on(type: string | number, callback: Function) {
    if (this.listeners[type] === undefined) {
      this.listeners[type] = [callback];
    } else {
      this.listeners[type].push(callback);
    }
  }

  /**
   * 取消监听事件
   * @param type 事件类型
   * @param callback 回调函数
   */
  off(type: string | number, callback: Function): boolean {
    if (typeof this.listeners[type] != "undefined") {
      const index = this.listeners[type].indexOf(callback);
      if (index === -1) {
        return false;
      } else {
        this.listeners[type].splice(index, 1);
        return true;
      }
    } else {
      return false;
    }
  }

  /**
   * 判断事件是否已经被监听
   * @param type 事件类型
   * @param callback 回调函数
   */
  has(type: string | number, callback: Function): boolean {
    if (typeof this.listeners[type] != "undefined") {
      return !!this.listeners[type].find(v => v === callback);
    }
    return false;
  }

  /**
   * 触发事件
   * @param type 事件类型
   * @param payload 相关参数
   */
  emit(type: string | number, ...payload: any): boolean {
    if (typeof this.listeners[type] != "undefined") {
      // eslint-disable-next-line prefer-rest-params
      this.listeners[type].forEach(v => {
        v.apply(this, payload);
      });
      return true;
    }
    return false;
  }
}

export default EventBus;
